<template>
  <div :class="headerClasses">
    <div
      class="max-w-site mx-auto sm:max-w-xl flex items-center sm:justify-center justify-between"
    >
      <ALogo
        class="sm:mt-1 sm:-mb-1"
        :show-baseline="false"
        :width="150"
        forced-color-mode="dark"
      />
      <div class="mt-0.5 -mb-0.5">
        <AMobileMenu
          v-if="$device.isMobile"
          :icon-attrs="{ class: 'text-white' }"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { twMerge } from 'tailwind-merge'

const props = defineProps<{
  headerTheme?: 'dark' | 'light'
}>()

const attrs = useAttrs()
const headerClasses = computed(() =>
  twMerge(
    'fixed top-0 left-0 right-0 border-b px-8 sm:pb-5 sm:pt-3.5 py-4 z-10',
    props.headerTheme === 'dark'
      ? 'bg-gray-800 text-white border-gray-700'
      : 'bg-white border-gray-200',
    attrs.class as string,
  ),
)
</script>

<style></style>
